export enum ModalType {
  UnsupportedBrowser,
  PickMusicSource,
  ChooseGenre,
  ChooseLoop,
  LabelDetails,
  ITunesSearch,
  EditAudio,
  DeleteAccount,
  AddResolution,
  SplitLayer,
  Export,
  Recording,
  FigmaWelcome,
  Unsplash,
  Gradients,
  Patterns,
  Shapes,
  SoundWaves,
  Processing,
  ReviewRecording,
  ShareVideo,
  Stickers,
  TemplateImageReplacement,
  CaptionsEditing,
  AddColorTheme,
  UploadCustomFont,
  BuyFigmaSubscription,
  SegmentationSurvey,
  FromDataOnboarding
}

export interface ModalData {
  type: ModalType;
  data?: any;
  uncloseable?: boolean;
}



// WEBPACK FOOTER //
// ./src/data/ModalData.ts